module.exports = __webpack_public_path__ + "static/media/09_before.d5653c8b.jpg";